module.exports = __webpack_public_path__ + "img/life.6be818a1.svg";